import { InMemoryCache } from '@apollo/client';
import { GET_PRIMARY_ACCOUNT_ID } from 'graphqls/profile';

export const initializePrimaryAccountId = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_PRIMARY_ACCOUNT_ID,
    data: {
      primaryAccountId: 0,
    },
  });
};

export default {
  resolvers: {
    Mutation: {
      primaryAccountId: (_, { primaryAccountId }, { cache }): null => {
        cache.writeQuery({
          query: GET_PRIMARY_ACCOUNT_ID,
          data: {
            __typename: 'primaryAccountId',
            primaryAccountId,
          },
        });

        return primaryAccountId;
      },
    },
  },
};
